import { ContactForm } from "../components/ContactForm";
import { PageHero } from "../components/PageHero";

export function WeddingPage() {
  return (
    <>
      <PageHero
        eyebrow="Bridal hair & makeup"
        title="Beautiful from first look to last dance."
        description="You’ve done the hard part. Let Nadia’s make your hair and makeup as memorable as the day itself, at the salon or on location."
        image="/images/wedding-hero.jpg"
      />

      <section className="section wedding-intro">
        <div className="container">
          <div className="wedding-offers">
            <article><span>01</span><h2>The bride</h2><p>A personalized consultation, trial-ready plan, and event-day styling designed around your dress, features, and schedule.</p><strong>Call for a free consultation</strong></article>
            <article><span>02</span><h2>The wedding party</h2><p>A coordinated approach for bridesmaids, family, and attendants without making everyone look the same.</p><strong>Custom party packages</strong></article>
            <article><span>03</span><h2>Flower girls</h2><p>Age-appropriate curls, braids, and polished styles that feel special and hold up through the celebration.</p><strong>Call for a free consultation</strong></article>
          </div>
        </div>
      </section>

      <section className="wedding-services">
        <article style={{ "--wedding-image": "url(/images/wedding-hair.jpg)" } as React.CSSProperties}>
          <div><p className="eyebrow eyebrow--light">Wedding hair</p><h2>From understated to unforgettable.</h2><p>Soft waves, polished updos, intricate braids, extensions, and veil-ready styling, planned to photograph beautifully and last.</p></div>
        </article>
        <article style={{ "--wedding-image": "url(/images/wedding-makeup.jpg)" } as React.CSSProperties}>
          <div><p className="eyebrow eyebrow--light">Wedding makeup</p><h2>Camera-ready. Still completely you.</h2><p>Professional makeup is available at Nadia’s during salon hours, with on-call and on-location appointments available.</p></div>
        </article>
      </section>

      <section className="party-note">
        <div className="container party-note__inner">
          <span>For parties of six or more</span>
          <p>We include champagne, orange juice, and hors d’oeuvres for in-salon celebrations. A 25% non-refundable deposit secures the event date.</p>
        </div>
      </section>

      <section className="section inquiry-section">
        <div className="container inquiry-grid">
          <div className="inquiry-copy">
            <p className="eyebrow">Tell us about your day</p>
            <h2>Let’s build your bridal beauty plan.</h2>
            <p>Share what you know today, even if the details are still moving. Our staff will follow up to confirm timing, availability, travel, and the right consultation.</p>
            <div className="inquiry-contact">
              <strong>Prefer to speak with someone?</strong>
              <p>Call <a href="tel:+17324467211">(732) 446-7211</a> and ask for Kevin, our special-event coordinator.</p>
            </div>
          </div>
          <ContactForm kind="wedding" />
        </div>
      </section>
    </>
  );
}
